// DS8.1M
import React from 'react';
import c from 'classnames';
import s from './ModalFooterMobile.scss';
const ModalFooterMobile = ({ className, primaryButton, secondaryButton, bottomExtras })=>{
    return /*#__PURE__*/ React.createElement("div", {
        className: c(className, s['root'])
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['buttons-wrapper']
    }, secondaryButton, primaryButton), bottomExtras && /*#__PURE__*/ React.createElement("div", {
        className: s['bottom-extras']
    }, bottomExtras));
};
ModalFooterMobile.displayName = 'ModalFooterMobile';
export default ModalFooterMobile;

//# sourceMappingURL=ModalFooterMobile.js.map